import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import styled from "styled-components";
import { useAppSelector } from "../../store/hooks";
import { checkRole } from "../recipe_page/recipe_page";

const LoadingShell = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 50vh;
  background-color: #c9febe;
  color: #355;
`;

type RequireAdminRouteProps = {
  children: React.ReactNode;
};

/**
 * Blocks admin pages until auth bootstrap finishes, then requires login + admin role.
 * Prevents admin UI from rendering (and firing API calls) before session is known.
 */
const RequireAdminRoute: React.FC<RequireAdminRouteProps> = ({ children }) => {
  const location = useLocation();
  const { token, role, bootstrapStatus } = useAppSelector((state) => state.auth);

  if (bootstrapStatus !== "ready") {
    return (
      <LoadingShell>
        <p>Loading session…</p>
      </LoadingShell>
    );
  }

  if (!token) {
    const returnTo = encodeURIComponent(`${location.pathname}${location.search}`);
    return <Navigate to={`/login?return=${returnTo}`} replace />;
  }

  if (!checkRole(role ?? "", "admin")) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default RequireAdminRoute;
